import { list } from '@wix/ambassador-pricing-plans-v2-benefit/http';
import { Benefit } from '@wix/ambassador-pricing-plans-v2-benefit/types';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { ControllerFlowAPI, IHttpClient } from '@wix/yoshi-flow-editor';
import { BOOKINGS_APP_DEF_ID } from '../constants';
import { isTruthy } from '../utils/isTruthy';

type ErrorHandler = ControllerFlowAPI['errorHandler'];

export interface BenefitsApi {
  listPlanBookingsBenefits(planId: string): Promise<Benefit[]>;
}

export class BenefitsService implements BenefitsApi {
  constructor(private httpClient: IHttpClient) {}

  public async listPlanBookingsBenefits(planId: string): Promise<Benefit[]> {
    const response = await this.httpClient.request(
      list({
        planIds: [planId],
        appDefIds: [BOOKINGS_APP_DEF_ID],
      }),
    );
    const { benefitsWithPlanInfo = [] } = response.data;
    return benefitsWithPlanInfo
      .filter(({ benefit }) => benefit && benefit.resourceIds?.length)
      .map((info) => info.benefit)
      .filter(isTruthy);
  }
}

export class BenefitsServiceWithErrorHandler implements BenefitsApi {
  constructor(private httpClient: IHttpClient, private errorHandler: ErrorHandler) {}

  public async listPlanBookingsBenefits(planId: string): Promise<Benefit[]> {
    const response = await this.errorHandler.withErrorHandler(
      async () =>
        this.httpClient.request(
          list({
            planIds: [planId],
            appDefIds: [BOOKINGS_APP_DEF_ID],
          }),
        ),
      { errorCodesMap: {} },
    );
    const { benefitsWithPlanInfo = [] } = response.data;
    return benefitsWithPlanInfo
      .filter(({ benefit }) => benefit && benefit.resourceIds?.length)
      .map((info) => info.benefit)
      .filter(isTruthy);
  }
}

export function createBenefitsApi(flowAPI: ControllerFlowAPI) {
  const isErrorHandlerEnabled = flowAPI.experiments.enabled(TPA_EXPERIMENTS.ERROR_HANDLER_TPA);

  if (isErrorHandlerEnabled) {
    return new BenefitsServiceWithErrorHandler(flowAPI.httpClient, flowAPI.errorHandler);
  }
  return new BenefitsService(flowAPI.httpClient);
}
